import React from "react";
import MasterLayout from "../../masterLayout/MasterLayout";
import Breadcrumb from "../../components/Breadcrumb";
import MediaLayer from "../../components/message/MediaLayer";

const ImagePage = () => {
  return (
    <>
      {/* MasterLayout */}
      <MasterLayout>
        {/* Breadcrumb */}
        <Breadcrumb title="Media Page" />


        {/* SingleLayer */}
        <MediaLayer />

      </MasterLayout>
    </>
  );
};

export default ImagePage;
